/* import __COLOCATED_TEMPLATE__ from './guidance-triggered-conversation-item.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import type { FormattedConversationGuidanceTriggered } from '../conversation-item';

export interface ConversationArgs {
  conversationItem: FormattedConversationGuidanceTriggered;
}

interface Signature {
  Args: ConversationArgs;
  Element: HTMLElement;
}

export default class GuidanceTriggeredConversationItem extends Component<Signature> {
  @service declare appService: AppService;

  get guidanceUrl(): string | null {
    let { guideline_id, match_type } = this.args.conversationItem;
    if (!guideline_id) {
      return null;
    }
    let appId = this.appService.app.id;
    if (match_type === 'escalation') {
      return `/a/apps/${appId}/automation/fin-ai-agent/escalation`;
    }
    return `/a/apps/${appId}/automation/fin-ai-agent/guidance/${guideline_id}`;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::ConversationItems::GuidanceTriggeredConversationItem': typeof GuidanceTriggeredConversationItem;
  }
}
